import React from "react";
import { Button } from "devextreme-react/button";

const ImovelButtonGroup = ({ props }) => {
  function retonarBotoes() {
    if (props.location.pathname === "/imoveis/novo") {
      return (
        <div>
          <Button className="botaoImovel" icon="home" text="Imóvel" />
          <Button
            className="botaoImovel"
            icon="globe"
            text="Terreno"
            disabled={true}
          />
          <Button
            className="botaoImovel"
            icon="chart"
            text="Edificação"
            disabled={true}
          />
          <Button
            className="botaoImovel"
            icon="formula"
            text="Cálculo do IPTU"
            width={200}
            disabled={true}
          />
        </div>
      );
    } else {
      return (
        <div>
          <Button
            className="botaoImovel"
            icon="home"
            text="Imóvel"
            onClick={() => {
              props.history.push("/imoveis/editar/" + props.match.params.id);
            }}
          />
          <Button
            className="botaoImovel"
            icon="globe"
            text="Terreno"
            onClick={() => {
              props.history.push(
                "/imoveis/editar/terreno/" + props.match.params.id
              );
            }}
          />
          <Button
            className="botaoImovel"
            icon="chart"
            text="Edificação"
            disabled={props._uiNatureza != "P"}
            onClick={() => {
              props.history.push(
                "/imoveis/editar/edificacao/" + props.match.params.id
              );
            }}
          />
          <Button
            className="botaoImovel"
            icon="formula"
            text="Cálculo do IPTU"
            width={180}
            onClick={() => {
              props.history.push(
                "/imoveis/editar/calculo-iptu/" + props.match.params.id
              );
            }}
          />
        </div>
      );
    }
  }

  return <div className="imovelButtons">{retonarBotoes()}</div>;
};

export default ImovelButtonGroup;
